import { render, staticRenderFns } from "./RsaConfigurazionePrestazioniAmbulatorialiEditComponent.vue?vue&type=template&id=377dab3f"
import script from "./RsaConfigurazionePrestazioniAmbulatorialiEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazionePrestazioniAmbulatorialiEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports